import { RegionProps } from '@/components/02-molecules/PartnerList/PartnerList'

export interface MapStateData {
  [stateCode: string]: {
    name: string
    cities: {
      [cityName: string]: string[]
    }
  }
}

/**
 * Maps region names from PartnerList to Australian state codes used in InteractiveMap
 */
const regionToStateMapping: Record<string, string> = {
  Victoria: 'VIC',
  'New South Wales': 'NSW',
  Queensland: 'QLD',
  'Western Australia': 'WA',
  'South Australia': 'SA',
  'Northern Territory': 'NT',
  Tasmania: 'TAS',
  'Australian Capital Territory': 'ACT',
  'New Zealand': 'NZ',
}

/**
 * Transforms PartnerList regions data into InteractiveMap state data format
 */
export const transformPartnerDataToMapData = (regions: RegionProps[]): MapStateData => {
  const mapData: MapStateData = {}

  regions.forEach((region) => {
    const stateCode = regionToStateMapping[region.name]

    if (stateCode) {
      const cities: { [cityName: string]: string[] } = {}

      // Use the processed offices from the region
      region.offices?.forEach((office) => {
        cities[office.name] = office.advisers.map((adviser) => adviser.name)
      })

      mapData[stateCode] = {
        name: region.name,
        cities,
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('No state code mapping found:', region.name)
    }
  })

  return mapData
}

/**
 * Gets advisers for a specific state from the transformed data
 */
export const getAdvisersForState = (mapData: MapStateData, stateCode: string) => {
  return mapData[stateCode] || null
}
